import { render } from "./IconFolderPlus.vue?vue&type=template&id=854930d2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFolderPlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "854930d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('854930d2', __exports__)) {
    api.reload('854930d2', __exports__)
  }
  
  module.hot.accept("./IconFolderPlus.vue?vue&type=template&id=854930d2", () => {
    api.rerender('854930d2', render)
  })

}


export default __exports__